// 🔧 social_step.js
// ✅ Purpose: Pipeline step for the LGV Social Engine
// ✅ Features:
// - Executes the Social Engine when selected
// - Runs after other add-ons so it can create promo drafts from generated data
// - Does NOT publish to any real social platform
// - Integrates with shared DemoContext
// - Returns standardized pipeline results
// - Fully block-commented for clarity and future devs

import { runSocialEngine } from "../../engines/social";

export const createSocialStep = () => ({
  id: "social_builder",

  name: "Social Builder",

  label: "Social Builder",

  run: async (demoContext) => {
    console.log("📣 Social Pipeline Step started.");

    const result = await runSocialEngine({
      demoContext,
    });

    console.log("✅ Social Pipeline Step completed.", {
      result,
    });

    return result;
  },
});